import api from '../api';

export const GetCustomerForRequest = async ({ token }: { token: string }) => {
    try {
        const { data } = await api.get<{ Data: any }>('v1/Sac/GetCustomerForRequest', {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });

        return { data: data.Data };
    } catch (error) {
        console.error('error', error);
        return { data: null };
    }
}
